import React from "react";
import api from "../../services/api";
import img from "../../assets/Adobe.png"
import Navbar from "../../components/navbar/index.jsx";
import {useState, useEffect} from 'react';
import {useParams}  from 'react-router-dom';
import "./listadocumento.css";

function ListaDocumento(props){
  
    let [dados,setdados] = useState([])
    let [qtde,setQtde] = useState(0)
    let [foto,setFoto] = useState('')
    var NomeUsuario = localStorage.getItem("NomeUsuario");
    const parametros = useParams(); 
    
    
    async function CarregaDocto()
    {
        const cnpj = localStorage.getItem("usuario");
        const UrlFoto = await api.get('../Img/?l=' + parametros.Chave.substring(0, 1));
        setFoto(UrlFoto.data[0].URL)
        const resultado = await api.get('/lstPdf/?p=' + cnpj+'&t='+parametros.Chave.substring(0, 1)+'&a='+parametros.Chave.substring(1,5)+'&m='+parametros.Chave.substring(5,7));
        setdados(resultado.data)   
        setQtde(resultado.data[0].IdFtp)
         
   //     console.log(resultado.data)

    }

    useEffect(()=>{
          CarregaDocto()
    },[]  );

   return<>

               { qtde === 0 ?
               
                    <div className="alert alert-secondary mt-2" role="alert">
                            Nenhum item a ser exibido !
                    </div>
                  :    
                
                    <div className="row">   
                         <Navbar/>     
                         <div className="m-2 mt-4 ">
                               <div className="invisivel">
                                    <h6> '' </h6> 
                                    <h1> '' </h1> 
                               </div> 
                               <h6> {NomeUsuario} </h6>
                         </div>                 
                         { dados.map(function(dado){
                                        return  <div className="col-md-4">
                                                       <div className="card">
                                                            <div className="card-header text-center">
                                                                 <img className="mt-1" src= {foto} alt={img} style={{ height: "22px", margin: "22px" }}/>
                                                                 <a href={dado.Arquivo}  target="_blank"> {dado.NomeRelatorio} </a> 
                                                            </div>
                                                            <div className="card-body text-center ">
                                                                 <p  className="card-text"> Data:  {dado.DtCad}</p>                                           
                                                            </div>
                                                       </div>
                                                  </div>  })

                                   }      
                    </div>   
             }

</>

}

export default ListaDocumento;
